import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useState } from 'react';
import { propArrayNum, propArrayShape, propArrayStr, propFunc, propId, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { useUnmountRef } from '../../../../../../../helpers/use/useHook';
import AccountTableEditRow from './AccountTableEditRow';
import AccountTableHead from './AccountTableHead';
import AccountTableRow from './AccountTableRow';
const AccountTable = (props) => {
    const { adminId, checkList, editableRowsObj, enableDomains, enableRows, newRows, onChangeAllCheck, onChangeCheck, onClickDisableAccount, onClickEditAccount, onClickEditCancelAccount, onClickSort, onClickUpdate, onSubmitEditAccount, onSubmitNewAccount, order, profile, sort, } = props;
    const fixRows = useMemo(() => [...enableRows, ...newRows], [enableRows, newRows]);
    const [emailStates, changeEmailStates] = useState({});
    const unmountRef = useUnmountRef();
    return (_jsxs("table", Object.assign({ className: 'mypage_slide_table' }, { children: [_jsx(AccountTableHead, { checkCount: checkList.length, itemCount: fixRows.length, onChangeCheck: onChangeAllCheck, onClickSort: onClickSort, onClickUpdate: onClickUpdate, order: order, sort: sort, unUseAccountCount: newRows.length }), _jsxs("tbody", { children: [fixRows.length === 0 && (_jsx("tr", Object.assign({ className: 'data_row row' }, { children: _jsx("td", Object.assign({ className: 'col empty_col', colSpan: 5 }, { children: "\u307E\u3060\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093" })) }))), fixRows.map((row, index) => {
                        const { initialValues, isEditable } = editableRowsObj[row.id] || {};
                        // 割り当てアカウントが存在しない、もしくは編集可能な状態の場合
                        if (!row.hasUser || isEditable) {
                            return (_jsx(AccountTableEditRow, { changeEmailStates: changeEmailStates, editableRowsObj: editableRowsObj, emailStates: emailStates, enableDomains: enableDomains, enableMembers: enableRows, form: `AccountTableEditRow_${row.id}_${index}`, index: index, initialValues: initialValues, item: row, onClickCancel: isEditable ? onClickEditCancelAccount : undefined, onSubmit: isEditable ? onSubmitEditAccount : onSubmitNewAccount, unmountRef: unmountRef }, row.id));
                        }
                        return (_jsx(AccountTableRow, { adminId: adminId, checkList: checkList, index: index, item: row, onChangeCheck: onChangeCheck, onClickDisableAccount: onClickDisableAccount, onClickEditAccount: onClickEditAccount, profile: profile }, row.id));
                    })] })] })));
};
AccountTable.propTypes = {
    adminId: propId(),
    checkList: propArrayNum().isRequired,
    editableRowsObj: propShape().isRequired,
    enableDomains: propArrayStr().isRequired,
    enableRows: propArrayShape().isRequired,
    newRows: propArrayShape().isRequired,
    onChangeAllCheck: propFunc().isRequired,
    onChangeCheck: propFunc().isRequired,
    onClickDisableAccount: propFunc().isRequired,
    onClickEditAccount: propFunc().isRequired,
    onClickEditCancelAccount: propFunc().isRequired,
    onClickSort: propFunc().isRequired,
    onClickUpdate: propFunc().isRequired,
    onSubmitEditAccount: propFunc().isRequired,
    onSubmitNewAccount: propFunc().isRequired,
    order: propStr().isRequired,
    profile: propShape().isRequired,
    sort: propStr().isRequired,
};
AccountTable.defaultProps = {
    adminId: null,
};
export default AccountTable;
